<template>
  <ul>
    <template
      v-for="menu in menus"
    >
      <template v-if="menu.view == 'anchor'">
        <li>
          <a :href="'/#' + menu.url">
            {{menu.title}}
          </a>
        </li>
      </template>
      <template v-else>
        <router-link
          tag="li"
          active-class="active"
          :to="link(menu)"
          :key="menu.url"
          exact
        >
          <a href="#">
            {{menu.title}}
          </a>
        </router-link>
      </template>
    </template>
  </ul>
</template>

<script>

  export default {
    props: {
      menus: Array | Object,
      hideMenuImage: Boolean
    },
    data () {
      return {
        baseUrl: process.env.VUE_APP_BACK_URL
      }
    },
    methods: {
      link: function (menu) {
        switch (menu.view) {
          case 'home':
            return '/'
          case 'page':
            return '/article/' + menu.slug
          case 'project':
            return '/project/' + menu.slug
          case 'page_blog':
            return '/blog/' + menu.slug
          case 'url':
            return '/' + menu.url
          case 'feedback':
            return '/feedback'
          default:
            return '#'
        }
      }
    }
  }
</script>
